// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1wymS","productName":"Table_productName__2WERD"};